export const SPECIAL_ACCOUNT_CAN_NOT_DELETE = [
  "global.marketing@nikonlenswear.com",
];
